<div class="content-body">
  <div class="content-title">Directions Features</div>
  <div class="content-subtitle">Tags for the Site and Cameras</div>
  <div class="description"> 
    <ul> 
      <li>Provide a quick understanding of key information about the protected location.  </li>
      <li>Defines the service exception of the site.  </li>
      <li>Defines the location's physical security posture.</li>
    </ul>
    <div class="position-tag">
      <div class="v-center" (mouseenter)="mouseEnterShowPosition($event, 'direction-tags')" (mouseleave)="mouseLeaveHidePosition($event)"><i class="material-icons">my_location</i>
        <div>Where is it?</div>
      </div>
    </div>
  </div>
  <hr/>
  <div class="content-subtitle">Directions</div>
  <div class="description"> 
    <ul> 
      <li>Concise and specific information about the site or specific cameras.  </li>
      <li>Provides an understanding of what operators need to be aware of.  </li>
      <li>Provides an understanding of how an operator should respond.</li>
    </ul>
    <div class="position-tag">
      <div class="v-center" (mouseenter)="mouseEnterShowPosition($event, 'direction')" (mouseleave)="mouseLeaveHidePosition($event)"><i class="material-icons">my_location</i>
        <div>Where is it?</div>
      </div>
    </div>
  </div>
  <hr/>
  <div class="content-subtitle">Editor / Preview</div>
  <div class="description"> 
    <ul> 
      <li>Review and edit the content of Directions.  </li>
      <li>Displays content exactly as it will appear in the Monitoring Portal.  </li>
      <li>Functional buttons allow safe testing and verification of Procedures.</li>
    </ul>
    <div class="position-tag">
      <div class="v-center" (mouseenter)="mouseEnterShowPosition($event, 'direction-preview')" (mouseleave)="mouseLeaveHidePosition($event)"><i class="material-icons">my_location</i>
        <div>Where is it?</div>
      </div>
    </div>
  </div>
  <hr/>
  <div class="content-subtitle">Paste feature</div><img src="assets/imgs/side-modal/paste_direction.png" alt="Paste Direction"/>
  <div class="description">
     The Paste feature in Directions allows you to easily copy and apply content from existing directions, including detailed information from Stored Procedures. <br/><br/>This feature is designed for user convenience, enabling you to quickly reuse and adapt previous content. <br/><br/>After pasting, you can modify the content as needed. If there are any pre-existing entries, you can cancel and revert to the original content effortlessly.
    <div class="position-tag">
      <div class="v-center" (mouseenter)="mouseEnterShowPosition($event, 'direction-paste')" (mouseleave)="mouseLeaveHidePosition($event)"><i class="material-icons">my_location</i>
        <div>Where is it?</div>
      </div>
    </div>
  </div>
</div>